
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events-calendar",
      function () {
        return require("private-next-pages/events-calendar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events-calendar"])
      });
    }
  